var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "card" },
    [
      _vm.alert
        ? _c(
            "div",
            { staticClass: "alert" },
            [
              _c("Icon", {
                staticClass: "alert__icon",
                attrs: { icon: "bell-01" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("Icon", { staticClass: "icon", attrs: { icon: _vm.icon } }),
      _vm._v(" "),
      _c("h3", [_vm._v(_vm._s(_vm.label))]),
      _vm._v(" "),
      _c("span", { staticClass: "value" }, [_vm._v(_vm._s(_vm.value ?? "-"))]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }